"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { useCallback } from "react"
import { LayoutGrid, Map } from "lucide-react"
import { cn } from "@/lib/utils"

type Props = {
  current: Record<string, string | undefined>
}

export function DirectoryViewToggle({ current }: Props) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const isMap = current.view === "map"

  const toggleView = useCallback(
    (view: "list" | "map") => {
      const params = new URLSearchParams(searchParams.toString())
      if (view === "map") {
        params.set("view", "map")
        params.delete("page")
        params.delete("sort")
      } else {
        params.delete("view")
      }
      router.push(`/directory?${params.toString()}`)
    },
    [router, searchParams]
  )

  return (
    <div className="flex items-center bg-white border border-[var(--border)] rounded-full p-0.5">
      <button
        onClick={() => toggleView("list")}
        className={cn(
          "flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full transition-colors",
          !isMap
            ? "bg-[var(--foreground)] text-white"
            : "text-[var(--muted-foreground)] hover:text-[var(--foreground)]"
        )}
      >
        <LayoutGrid size={13} />
        List
      </button>
      <button
        onClick={() => toggleView("map")}
        className={cn(
          "flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full transition-colors",
          isMap
            ? "bg-[var(--foreground)] text-white"
            : "text-[var(--muted-foreground)] hover:text-[var(--foreground)]"
        )}
      >
        <Map size={13} />
        Map
      </button>
    </div>
  )
}
